'use client'

import React from 'react'
import orangeNote from '@/assets/img/details/stats-notes/note-orange.svg'
import brightBlueNote from '@/assets/img/details/stats-notes/note-bright-blue.svg'
import blueNote from '@/assets/img/details/stats-notes/note-blue.svg'
import darkBlueNote from '@/assets/img/details/stats-notes/note-dark-blue.svg'
import Image from 'next/image'
import { Pie } from 'react-chartjs-2'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

Chart.register(ArcElement, Tooltip, Legend)

interface Props {
    selectedSlide?: number
}

const DetailsAboutSlide: React.FC<Props> = ({ selectedSlide }) => {
    const { t } = useTranslation()

    const notesArr = [
        {
            text: t('MEGAMIX_Group'),
            img: orangeNote
        },
        {
            text: t('Other_Russian_manufacturers'),
            img: brightBlueNote
        },
        {
            text: t('Foreign_companies'),
            img: blueNote
        },
        {
            text: t('others'),
            img: darkBlueNote
        }
    ]

    const data = () => {
        return {
            datasets: [
                {
                    data: [22.5, 22.5, 22.5, 32],
                    backgroundColor: [
                        'rgba(80, 105, 202, 0.8)',
                        'rgba(103, 136, 221, 0.8)',
                        'rgba(63, 83, 162, 0.8)',
                        'rgba(255, 159, 110, 1)'
                    ],
                    borderColor: [
                        'rgba(255, 255, 255, 0)',
                        'rgba(255, 255, 255, 0)',
                        'rgba(255, 255, 255, 0)',
                        'rgba(255, 255, 255, 0)',
                        'rgba(255, 255, 255, 0)',
                        'rgba(255, 255, 255, 0)'
                    ]
                }
            ]
        }
    }

    return (
        <li className='main-details__slide product__slide'>
            <h3 className='main-about__card-title'>{t('About_us_title')}</h3>
            <div className='main-about__card-text-content'>
                <p className='main-details__description product__chapter-description'>{t('About_us_content')}</p>
            </div>
            <div className='main-details__stats'>
                <ul className='main-details__stats-notes'>
                    {notesArr?.map((note, i) => (
                        <li
                            className='main-details__stats-note'
                            key={i}
                        >
                            <div className='main-details__stats-note-img'>
                                <Image
                                    src={note.img}
                                    width={44}
                                    height={8}
                                    alt='note'
                                />
                            </div>
                            <p>{note.text}</p>
                        </li>
                    ))}
                </ul>

                {document.querySelector('.card-slider__container') &&
                    createPortal(
                        <div
                            style={selectedSlide === 0 ? {} : { opacity: 0 }}
                            className='card-details__chart'
                        >
                            <p>32%</p>
                            <Pie
                                redraw={true}
                                // options={options}
                                data={data()}
                                width={186}
                                height={186}
                            />
                        </div>,
                        document.querySelector('.card-slider__container')
                    )}
            </div>
        </li>
    )
}

export default DetailsAboutSlide
